import React, { Fragment, useState } from 'react';
import styles from './TopicItem.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useDelete } from 'hooks/useDelete';
import { topics } from 'hooks/endpoints';
import ConfirmationModal from 'component/hoc/success-modal/ConfirmationModal';
import NewTopic from './NewTopic';
import Tooltip from 'component/Custom/tooltip/Tooltip';

const TopicItem = ({ topic, refetch }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const { mutate: deleteTopic, isPending: isPendingDelete } = useDelete({
    onSuccessToast: 'Topic deleted successfully',
    toastType: 'add',
  });

  const handleDelete = () => {
    deleteTopic(
      {
        url: topics.deleteTopic(topic?.topicId),
      },
      {
        onSuccess: () => {
          refetch();
          setShowDeleteModal(false);
        },
      },
    );
  };

  return (
    <Fragment>
      <div className={styles['topics-item']} key={topic?.topicId}>
        <p className={styles['title']}>
          {' '}
          <Tooltip content={topic?.topicText}>{topic?.topicText}</Tooltip>
        </p>
        <div className={styles['actions']}>
          <SvgWithBranding
            type='edit'
            className={styles['icon']}
            onClick={() => {
              setShowEditModal(true);
            }}
          />
          <SvgWithBranding
            type='delete2'
            className={styles['icon']}
            onClick={() => {
              setShowDeleteModal(true);
            }}
          />
        </div>
      </div>
      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onSubmit={handleDelete}
        closeOnSubmit={true}
        onApproveButton={{ text: 'Delete' }}
        text='Delete Topic'
        subText={`Are you sure you want to delete the topic "${topic?.topicText}"? This action cannot be undone.`}
        isLoading={isPendingDelete}
      />
      <NewTopic
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        refetch={refetch}
        item={topic}
      />
    </Fragment>
  );
};

export default TopicItem;
